export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/deep-link.3a177608.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};